import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_SUGGESTION_ACCEPTREJECT } from './url-constants';

type ResetUserSuggestionEndpointSpecification = ApiEndpointSpecification;
export const ResetUserSuggestionEndpointSpecification: ResetUserSuggestionEndpointSpecification = {

    url: ALARM_SUGGESTION_ACCEPTREJECT,
    method:HttpMethod.DELETE,
    requestParamsSchemaName: 'ResetUserSuggestionRequestParams',
    requestBodySchemaName: 'ResetUserSuggestionRequestBody',
    okResponseSchemaName: 'ResetUserSuggestionOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 2.0
};

export const invokeResetUserSuggestion = Helpers.makeApiRequestFn<
Types.ResetUserSuggestionRequestParams,
Types.ResetUserSuggestionRequestBody,
Types.ResetUserSuggestionOkResponse
>(ResetUserSuggestionEndpointSpecification);
